import { Typography, styled } from '@mui/material'

/**
 * A styled Typography component for section headers.
 * Provides consistent bold styling with bottom margin.
 *
 * @example
 * <SectionHeader variant="h5" gutterBottom>
 *   Section Title
 * </SectionHeader>
 */
export const SectionHeader = styled(Typography)(({ theme }) => ({
  fontWeight: 'bold',
  marginBottom: theme.spacing(2),
}))

export default SectionHeader
